/** English mirror of ./strings.ar.js. */
export const shell = {
  toggleSidebar: 'Show sidebar menu',
  menu: 'Main menu',
  userPanel: 'User Panel',
  userGuide: 'User Manual',
  consoleLogs: 'Console logs',
  profile: 'Profile',
  account: 'Account',
  logout: 'Logout',
  close: 'Close',
  version: 'Version',
  language: 'Language',

  search: 'Search pages and sections',
  searchEmpty: 'No matching results',
  searchClear: 'Clear search',
  searchRecent: 'Recently opened',
  searchPages: 'Pages',
  searchSections: 'Sections',
  searchActions: 'Actions',
  searchMove: 'to move',
  searchOpen: 'to open',
  searchClose: 'to close',

  placeholderTitle: 'This page is being built',
  placeholderDesc: 'This screen arrives in a later stage of the redesign.',

  sessionErrorTitle: 'Cannot reach the server',
  sessionErrorDesc: 'Your session details could not be read. Check the connection and try again.',
  retry: 'Try again',
}
